import React from "react";
import { View } from "react-native";
import Skeletons from "./Skeletons";

const GoLiveOverviewSkeleton = ({ styles }) => {
  return (
    <View style={[styles.OverView, { marginRight: 10 }]}>
      <View style={{}}>
        <Skeletons
          height={20}
          width={"165px"}
          style={{
            borderRadius: 10,
            marginLeft: 10,
            marginBottom: 10,
          }}
        />

        <Skeletons
          height={"70vh"}
          width={"98%"}
          style={{
            borderRadius: 10,
            marginLeft: 10,
          }}
        />
      </View>
    </View>
  );
};

export default GoLiveOverviewSkeleton;
